import Icon from '../components/Icon.vue'

Icon.register({
  map: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M0 117.7c0-12 9-25.3 20.1-29.7l139.9-56v384l-138.1 62.8c-10.5 4.2-21.9-3.5-21.9-14.9v-346.3zM192 416v-384l192 64v384zM554.1 33.2c10.5-4.2 21.9 3.5 21.9 14.9v346.3c0 12-9 25.3-20.1 29.7l-139.9 56v-384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map.js
// module id = 1546
// module chunks = 0